export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  EJECUTIVO = 'ROLE_EJECUTIVO',
  GESTOR = 'ROLE_GESTOR',
}
